import {atom} from "recoil";

export const sidebarState = atom<boolean>({
  key: "sideBarOpen",
  default: false,
});
